import queries from '@apis/queries';
import Card from '@components/Card';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    cardId: string;
}

function PrepaidCardInfo({ cardId }:Props) {
    const { t } = useTranslation('prepaidCard');
    const { data } = useQuery(queries.userPrepaidCard.detail(cardId));
    return (
        <div className={styles.wrapper}>
            <Card className={styles.body}>
                <Row spacing={16}>
                    <Image src={data?.imageUrl}
                        width={90}
                        height={60}
                        alt={t('components.info.cardAlt')} />
                    <Text size='lg'>
                        {data?.name}
                    </Text>
                </Row>
            </Card>
        </div>
    );
}

export default PrepaidCardInfo;
